import { combineReducers } from 'redux';
import { intlReducer } from 'react-intl-redux'
import homeReducer from './home_reducer';
import indexReducer from './index_reducer';
import loginReducer from './login_reducer';
import deviceMonitorReducer from './deviceMonitor_reducer';
import deviceMonitorTreeReducer from './deviceMonitorTree_reducer';
import equipmentReducer from './equipment_reducer';
import operationReducer from './operation_reducer';
import operationFlowReducer from './operationflow_reducer';
import navbarReducer from './navbar_reducer';
import systemReducer from './system_reducer';
import alarmReducer from './alarm_reducer';
import localesReducer from './locales_reducer';
import weChatReducer from './weChat_reducer';
import reportReducer from './report_reducer';
// import assetManageReducer from './assetManage_reducer';
// import assetReportReducer from './assetReport_reducer';
import settingReducer from './setting_reducer';
import threeDPerspectiveDiagramReducer from './threeDPerspectiveDiagram_reducer';
import operationAuditReducer from './operationAudit_reducer';  // 操作审计
// import remoteReducer from './remote_reducer';  // 远程桌面，后续使用
import ems_reducer from './ems_reducer';
import closeReducer from './close_reducer';

const rootReducer = combineReducers({
  homeReducer,
  indexReducer,
  loginReducer,
  equipmentReducer,
  deviceMonitorReducer,
  operationReducer,
  operationFlowReducer,
  deviceMonitorTreeReducer,
  navbarReducer,
  systemReducer,
  alarmReducer,
  intl: intlReducer,
  locales: localesReducer,
  weChatReducer,
  reportReducer,
  // assetManageReducer,
  // assetReportReducer
  settingReducer,
  threeDPerspectiveDiagramReducer,
  operationAuditReducer,
  // remoteReducer,
  ems_reducer,
  closeReducer
});

export default rootReducer;
